(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    console.info('Starter: JS prêt.');
  });
})();
